.root {
  position: relative;
}

.trigger {
  display: inline-flex;
  min-width: 8.5rem;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding-inline: var(--space-2-5);
  cursor: pointer;
}

.trigger:hover,
.trigger[data-expanded] {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon {
  display: inline-grid;
  flex: 0 0 auto;
  place-items: center;
  color: var(--color-muted);
  transition: transform var(--duration-normal) var(--ease-out);
}

.icon[data-expanded] {
  transform: rotate(180deg);
}

.icon svg,
.indicator svg {
  width: 1em;
  height: 1em;
}

.content {
  width: min(var(--kb-popper-anchor-width), var(--kb-popper-content-available-width));
  max-height: min(18rem, var(--kb-popper-content-available-height));
  transform-origin: var(--kb-select-content-transform-origin);
  animation: selectIn var(--duration-fast) var(--ease-out);
}

.listbox {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  outline: none;
}

.item {
  display: flex;
  justify-content: space-between;
  font-size: var(--text-sm);
}

.item[data-highlighted] {
  color: var(--color-fg-strong);
}

.itemLabel {
  min-width: 0;
}

.indicator {
  display: inline-grid;
  place-items: center;
  color: var(--color-accent);
}

@keyframes selectIn {
  from {
    opacity: 0;
    transform: scale(0.98) translateY(-0.125rem);
  }
}
